export const NOTIFICATION_PLACEMENT = {
  MODAL: 'MODAL',
  GLOBAL: 'GLOBAL',
};
